module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "sideUp"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTips),
      expression: "showTips"
    }]
  }, [_c('div', {
    staticClass: "tips-mask",
    on: {
      "touchmove": function($event) {
        $event.preventDefault();
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tips"
  }, [_c('div', {
    staticClass: "tips-content"
  }, [_c('p', {
    staticClass: "tips-title"
  }, [_vm._v(_vm._s(_vm.tipTitle))]), _vm._v(" "), _c('button', {
    staticClass: "tips-ok",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.clickOkBtn()
      }
    }
  }, [_vm._v(_vm._s(_vm.okBtnText))]), _vm._v(" "), _c('button', {
    staticClass: "tips-cancle",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.hideTips()
      }
    }
  }, [_vm._v("取消")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-04909085","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tips/tips.vue
// module id = 212
// module chunks = 3